const benefits = [
	{
		icon: 'img/icons/notification.svg',
		title: 'Notifikace',
		desription: 'Notifikace v aplikaci si čte přes\n 90 % lidí.',
	},
	{
		icon: 'img/icons/marketing.svg',
		title: 'Efektivní marketing',
		desription: 'Náklady na získání zákazníka\n je levnější?',
	},
	{
		icon: 'img/icons/emails.svg',
		title: 'Sběr e-mailů',
		desription: 'V aplikaci je jednoduchý a\n efektivní sběr e-mailů.',
	},
	{
		icon: 'img/icons/advantage.svg',
		title: 'Konkurenční výhoda',
		desription: 'Buďte inovativní a nabídněte\n zákazníkům něco nového.',
	},
]

const AppBenefits = () => {
	return (
		<section className="mb-20 mt-16 sm:mt-28" id="benefits">
			<h2 className="mb-10 hidden text-center text-4xl font-bold sm:block">
				Proč mít vlastní aplikaci?
			</h2>
			<div className="bg-turquoise">
				<div className="relative -bottom-20 mx-10 flex flex-col gap-6 sm:grid sm:grid-cols-4">
					{benefits.map(benefit => (
						<BenefitBox
							key={benefit.title}
							icon={benefit.icon}
							title={benefit.title}
							desription={benefit.desription}
						/>
					))}
				</div>
			</div>
		</section>
	)
}

const BenefitBox = ({
	icon,
	title,
	desription,
}: {
	icon: string
	title: string
	desription: string
}) => {
	return (
		<div className="flex min-h-60 flex-col items-center gap-6 rounded-2xl bg-white p-8  shadow-custom">
			<img src={icon} alt={title} />
			<div className="flex flex-col gap-2 text-center">
				<h3 className=" text-lg font-bold">{title}</h3>
				<p className=" whitespace-pre-line">{desription}</p>
			</div>
		</div>
	)
}

export default AppBenefits
